/**
 * Re-attaches link sheets that the browser detached from a shadow root: loaded (`sheet` set) but
 * missing from `styleSheets`. Chromium <152 does this on `Element.moveBefore()` (AVS-4487).
 * Re-inserting the same link in place makes the browser apply it again; a still-loading link
 * attaches on its own when the load completes.
 *
 * @returns how many links were re-attached
 */
export function reattachDetachedStylesheets(root: ShadowRoot): number {
  const applied = Array.from(root.styleSheets ?? []);
  let reattached = 0;

  for (const link of Array.from(root.querySelectorAll<HTMLLinkElement>('link[rel~="stylesheet"]'))) {
    if (link.sheet && !applied.includes(link.sheet)) {
      link.parentNode?.insertBefore(link, link.nextSibling);
      reattached += 1;
    }
  }

  return reattached;
}
